<template lang="pug" src="./slider-testimonials.pug"></template>

<script>
import SliderTestimonialsDirective from './slider-testimonials.directive'
export default {
  computed: {
    props () {
      return this.$store.state.pages.testimonials
    }
  },
  directives: {
    SliderTestimonialsDirective
  }
}
</script>



// WEBPACK FOOTER //
// slider-testimonials.vue?0722d17e